export const CONTENT_TYPES = {
  page: "page",
  quiz: "quiz",
  subpage: "subpage",
};
